import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, Offcanvas } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const AdminNavbar = ({ onLogout, user }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt' },
    { path: '/admin/academic-years', label: 'Academic Years', icon: 'fas fa-calendar-alt' },
    { path: '/admin/departments', label: 'Departments', icon: 'fas fa-sitemap' },
    { path: '/admin/about_college', label: 'About Us', icon: 'fas fa-sitemap' },
    { path: '/admin/courses', label: 'Courses', icon: 'fas fa-book' },
    { path: '/admin/staff', label: 'Staff', icon: 'fas fa-user-tie' },
    { path: '/admin/events', label: 'Events', icon: 'fas fa-calendar-check' },
    { path: '/admin/gallery', label: 'Gallery', icon: 'fas fa-images' },
  ];

  return (
    <>
      {/* Top Navigation Bar */}
      <Navbar bg="dark" variant="dark" expand="lg" className="sticky-top shadow-sm">
        <Container fluid>
          <Button
            variant="outline-light"
            onClick={() => setShowSidebar(true)}
            className="me-2"
          >
            <i className="fas fa-bars"></i>
          </Button>
          
          <Navbar.Brand as={Link} to="/admin/dashboard" className="fw-bold">
            <i className="fas fa-university me-2"></i>
            College Admin
          </Navbar.Brand>
          
          <Nav className="ms-auto align-items-center">
            {user && (
              <Nav.Item className="text-light me-3 d-none d-md-block">
                <i className="fas fa-user-circle me-2"></i>
                {user.username}
              </Nav.Item>
            )}
            <Button
              variant="outline-light"
              size="sm"
              onClick={onLogout}
            >
              <i className="fas fa-sign-out-alt me-2"></i>
              Logout
            </Button>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar */}
      <Offcanvas
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        placement="start"
        style={{ width: '250px' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <i className="fas fa-university me-2 text-primary"></i>
            Admin Menu
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="sidebar-menu">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-item d-flex align-items-center p-3 border-bottom text-decoration-none ${
                  isActive(item.path) ? 'active' : ''
                }`}
                onClick={() => setShowSidebar(false)}
              >
                <i className={`${item.icon} me-3`}></i>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AdminNavbar;